import { render, staticRenderFns } from "./Items.vue?vue&type=template&id=c287da8e&scoped=true&v-on-clickaway=cancel&"
import script from "./Items.vue?vue&type=script&lang=ts&"
export * from "./Items.vue?vue&type=script&lang=ts&"
import style0 from "./Items.vue?vue&type=style&index=0&id=c287da8e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c287da8e",
  null
  
)

export default component.exports